import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { environment } from 'src/environments/environment';
import { UbicacionService } from 'src/app/services/ubicacion/ubicacion.service';
import { Pais } from 'src/app/interfaces/ubicaciones';
import { JwtResponse } from 'src/app/interfaces/jwt';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-completar-empresa',
  templateUrl: './completar-empresa.component.html',
  styleUrls: ['./completar-empresa.component.scss']
})
export class CompletarEmpresaComponent implements OnInit {

  form: FormGroup;
  paises: Pais[] = [];
  enviando = false;
  error = '';
  currentUser: JwtResponse | null = null;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private http: HttpClient,
    private ubicacionService: UbicacionService,
    private authService: AuthService,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.currentUser = JSON.parse(localStorage.getItem('currentUser') || 'null');
      if (!this.currentUser || this.currentUser.role !== 'empresa') {
        this.router.navigate(['/acceder']);
        return;
      }
      if (this.currentUser.user?.perfilCompleto === true) {
        this.router.navigate(['/empresa']);
        return;
      }
    }

    this.form = this.fb.group({
      nombreComercial: [this.currentUser?.user?.nombre || '', Validators.required],
      razonSocial:     ['', Validators.required],
      rfc:             ['', [Validators.required, Validators.minLength(12), Validators.maxLength(14)]],
      giroEmpresarial: ['', Validators.required],
      telefono:        ['', Validators.required],
      pais:            ['México', Validators.required],
      idEstado:        [null],
      idCiudad:        [null],
      direccion:       [''],
    });

    this.ubicacionService.obtenerPaises().then((data: any) => {
      this.paises = data?.data || data || [];
    });
  }

  guardar(): void {
    if (this.form.invalid) { this.form.markAllAsTouched(); return; }
    this.enviando = true;
    this.error = '';

    const token = this.currentUser?.token;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });

    this.http.put(`${environment.baseApi}/empresa/completar-perfil`, this.form.value, { headers })
      .subscribe({
        next: () => {
          if (this.currentUser) {
            this.currentUser.user.perfilCompleto = true;
            localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
            this.authService.setCurrentUserValue(this.currentUser);
          }
          if (isPlatformBrowser(this.platformId)) {
            window.location.href = '/empresa';
          } else {
            this.router.navigate(['/empresa']);
          }
        },
        error: (err) => {
          this.error = err?.error?.message || err?.error?.messageError || 'Error al guardar. Intenta de nuevo.';
          this.enviando = false;
        }
      });
  }
}
